const initialState = {
  getMember: {},
  getMale: {},
  getTransgender: {},
  getFemale: {},
  createState: 0,
  delState: 0,
  upadtesate: 0,
  putState: 0,
  deleteState: 0,
  readState: 0,
  getState: 0,
  getTodo: [],
  getNotification: [],
  getData: 0,
  user: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_POPULATION_COUNT_FULFILLED":
      return {
        ...state,
        getState: 2,
        getMember: action.payload.data,
      };
    case "GET_POPULATION_COUNT_REJECTED":
      return { ...state, getState: 3 };
    case "GET_POPULATION_COUNT_PENDING":
      return { ...state, getState: 1 };
    case "GET_MALE_POPULATION_COUNT_FULFILLED":
      return {
        ...state,
        getState: 2,
        getMale: action.payload.data,
      };
    case "GET_MALE_POPULATION_COUNT_REJECTED":
      return { ...state, getState: 3 };
    case "GET_MALE_POPULATION_COUNT_PENDING":
      return { ...state, getState: 1 };
    case "GET_FAMALE_POPULATION_COUNT_FULFILLED":
      return {
        ...state,
        getState: 2,
        getFemale: action.payload.data,
      };
    case "GET_FAMALE_POPULATION_COUNT_REJECTED":
      return { ...state, getState: 3 };
    case "GET_FAMALE_POPULATION_COUNT_PENDING":
      return { ...state, getState: 1 };
    case "GET_TRANSGENDER_POPULATION_FULFILLED":
      return {
        ...state,
        getStateTrans: 2,
        getTransgender: action.payload.data,
      };
    case "GET_TRANSGENDER_POPULATION_REJECTED":
      return { ...state, getState: 3 };
    case "GET_TRANSGENDER_POPULATION_PENDING":
      return { ...state, getState: 1 };
    case "GET_USER_TODO_FULFILLED":
      return {
        ...state,
        fetchState: 2,
        getTodo: action.payload.data,
      };
    case "GET_USER_TODO_REJECTED":
      return { ...state, fetchState: 3 };
    case "GET_USER_TODO_PENDING":
      return { ...state, fetchState: 1 };

    case "EDIT_USER_FULFILLED":
      return {
        ...state,
        fetchState: 2,
        user: action.payload.data,
      };
    case "EDIT_USER_REJECTED":
      return { ...state, fetchState: 3 };
    case "EDIT_USER_PENDING":
      return { ...state, fetchState: 1 };

    case "UPLOAD_PROFILE_PENDING":
      return { ...state, uploadState: 1 };
    case "UPLOAD_PROFILE_FULFILLED":
      return { ...state, uploadState: 2, user: action.payload.data };
    case "UPLOAD_PROFILE_REJECTED":
      return { ...state, uploadState: 3 };

    case "GET_USER_BY_ID_PENDING":
      return { ...state, readState: 1 };
    case "GET_USER_BY_ID_FULFILLED":
      return { ...state, readState: 2, user: action.payload.data };
    case "GET_USER_BY_ID_REJECTED":
      return { ...state, readState: 3 };

    case "GET_NOTIFICATION_REJECTED":
      return { ...state, getData: 3 };
    case "GET_NOTIFICATION_PENDING":
      return { ...state, getData: 1 };

    case "GET_NOTIFICATION_FULFILLED":
      return {
        ...state,
        getData: 2,
        getNotification: action.payload.data,
      };

    case "GET_NOTIFICATION_PREG_REJECTED":
      return { ...state, getData: 3 };
    case "GET_NOTIFICATION_PREG_PENDING":
      return { ...state, getData: 1 };

    case "GET_NOTIFICATION_PREG_FULFILLED":
      return {
        ...state,
        getData: 2,
        getNotification: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;
